
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    activeTab: { type: String, required: true }
  },
  emits: ['tabClicked'],
  setup() {
    const tabs = [
      'email',
      'letter',
      'sms',
      'rcs',
      'whatsapp',
      'plain',
      'mjml',
      'html',
      'image'
    ]
    return { tabs }
  }
})
